export function escapeHtml (s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/escapeHtml.js